import React, { useEffect } from "react";
import { mainColor } from "../../styles/global";
import { Container, NavLink } from "./Styles";

export const ComingSoon = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Container>
        <div>
          <img src="img/Emoji.svg" alt="" />
        </div>
        <h3 style={{ color: `${mainColor}` }}>Coming Soon</h3>
        <NavLink to="/">Go back to Homepage</NavLink>
      </Container>

    </div>
  );
};
